import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M213.333 0C95.5126 0 0 95.5126 0 213.333V1706.67C0 1824.49 95.5126 1920 213.333 1920H1706.67C1824.49 1920 1920 1824.49 1920 1706.67V213.333C1920 95.5126 1824.49 0 1706.67 0H213.333ZM320 1200C320 1155.82 355.817 1120 400 1120H1093.33C1137.52 1120 1173.33 1155.82 1173.33 1200C1173.33 1244.18 1137.52 1280 1093.33 1280H400C355.817 1280 320 1244.18 320 1200ZM1386.67 1200C1386.67 1155.82 1422.48 1120 1466.67 1120H1520C1564.18 1120 1600 1155.82 1600 1200C1600 1244.18 1564.18 1280 1520 1280H1466.67C1422.48 1280 1386.67 1244.18 1386.67 1200ZM746.667 1520C746.667 1475.82 782.484 1440 826.667 1440H1520C1564.18 1440 1600 1475.82 1600 1520C1600 1564.18 1564.18 1600 1520 1600H826.667C782.484 1600 746.667 1564.18 746.667 1520ZM320 1520C320 1475.82 355.817 1440 400 1440H453.333C497.516 1440 533.333 1475.82 533.333 1520C533.333 1564.18 497.516 1600 453.333 1600H400C355.817 1600 320 1564.18 320 1520Z",
  fillRule: "evenodd"
});

var IconSubtitlesSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSubtitlesSolid, _Component);

  var _super = _createSuper(IconSubtitlesSolid);

  function IconSubtitlesSolid() {
    _classCallCheck(this, IconSubtitlesSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSubtitlesSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSubtitles",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSubtitlesSolid.displayName = "IconSubtitlesSolid";
  return IconSubtitlesSolid;
}(Component);

IconSubtitlesSolid.glyphName = 'subtitles';
IconSubtitlesSolid.variant = 'Solid';
IconSubtitlesSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSubtitlesSolid;
export { IconSubtitlesSolid };